//**** 香港雲域名 ****
// const _baseUrl_ = 'https://jyb-admin-backend.aoyunltd.com'

//**** 深圳雲測試域名 ****
// const _baseUrl_ = "http://jyb-admin-backend-test.aoyunltd.cn";

//**** 新加坡測試域名 ****
// const _baseUrl_ = "http://api.test.aoyunltd.cn";

//**** 香港雲測試域名 ****
// const _baseUrl_ = "https://jyb-admin-backend-hktest.aoyunltd.com:1443";

const _baseUrl_ = process.env.VUE_APP_API_URL
console.log({ _baseUrl_ })
const env = process.env.NODE_ENV
console.log({ env })

export default {
  baseUrl: _baseUrl_,

  //**** 查詢快件 **** 1 API count
  all_search: _baseUrl_ + '/api/v1/goods/info/sech', //查詢快件

  all_search_detail_new: _baseUrl_ + '/api/v1/order/serch/newinfos', //查詢快件详情

  all_search_new: _baseUrl_ + '/api/v1/jyb/admin/stadd/order/all/infos', //查詢快件

  all_search_new2: _baseUrl_ + '/api/v1/jyb/admin/stadd/order/all/infos/nav', //查詢快件

  //**** 首頁 **** 1 API count
  login: _baseUrl_ + '/api/v1/admin/login/password', //集運幫登錄

  //**** 統計圖表 **** 6 API count
  home_zhuhai: _baseUrl_ + '/api/v1/echarts/list', //統計圖表->珠海倉庫->出入庫ECharts

  home_macao_originating: _baseUrl_ + '/api/v1/echarts/list_macao_originating', //統計圖表->澳門倉庫->出入庫ECharts

  home_macao_pickup: _baseUrl_ + '/api/v1/echarts/list_macao_pickup', //統計圖表->門店未簽收和已簽收Echarts

  home_smartbox_pickup: _baseUrl_ + '/api/v1/echarts/list_smartbox_pickup', //統計圖表->智能櫃未簽收和已簽收Echarts

  home_views_daily_outtime:
    _baseUrl_ + '/api/v1/echarts/list_views_daily_outtime', //統計圖表->快遞統計(全局)Echarts

  home_views_daily_zhuhai_outtime:
    _baseUrl_ + '/api/v1/echarts/list_views_daily_zhuhai_outtime', //統計圖表->快遞統計(門店)Echarts

  //**** 珠海倉庫 **** 20 API count
  scanIn: _baseUrl_ + '/api/v1/admin/goods', //掃描入庫
  goodsPs: _baseUrl_ + '/api/v1/admin/goodsPs', //掃描入庫2
  scanIn2: _baseUrl_ + '/api/v1/express/storage/record', //掃描入庫
  scanIn3: _baseUrl_ + '/api/v1/express/storage', //掃描入庫

  orderScanOutSearch: _baseUrl_ + '/api/v1/order/serch/order/out', //掃描 出库查询

  isorder: _baseUrl_ + '/api/v1/order/serch/isorder', //掃描入庫 查询订单是否存在

  getSignList: _baseUrl_ + '/api/v1/order/goods/count/shelf', //

  notSigncont: _baseUrl_ + '/api/v1/order/goods/count/all', //

  zhoutList: _baseUrl_ + '/api/v1/admin/good/zhout/list', //已出库

  scanIn_new: _baseUrl_ + '/api/v1/admin/good/zhin/list', //掃描入庫 new

  bagNumberTable: _baseUrl_ + '/api/v1/express/package/list',// 大包号列表

  scanOut: _baseUrl_ + '/api/v1/admin/goods/out', //掃碼出庫

  packageType: _baseUrl_ + '/api/v1/admin/goods/type', //包裹類型

  pickAddress: _baseUrl_ + '/api/v1/admin/store', //提貨櫃點 (type=1是門店,type=2是智能櫃)

  pickAdmin: _baseUrl_ + '/api/v1/admin/list', //操作員列表

  feesAddPrice: _baseUrl_ + '/api/v1/order/admin/addfee', //给订单追加费用

  getInfoByPhone: _baseUrl_ + '/api/v1/admin/member/info', //手機號獲取用戶信息

  logisticsInfo: _baseUrl_ + '/api/v1/admin/goods/logistics', //物流信息

  // scanSpecial: _baseUrl_ + "/api/v1/admin/goods/shelf/special", //特殊掃描

  deliverCode: _baseUrl_ + '/api/v1/admin/goods/barCode', //打印條碼

  deliverCode2: _baseUrl_ + '/api/v1/admin/goods/barPrint', //打印條碼 新接口

  deliverCode3: _baseUrl_ + '/api/v1/data/delivery/area/lists/pdf', //打印條碼 新接口

  deliverCode4: _baseUrl_ + '/api/v1/order/print/inorder', //打印條碼 新街口，  获取数据

  deliverCode5: _baseUrl_ + '/api/v1/data/delivery/area/lists/pdf/new', //打印條碼 新接口

  insertTook: _baseUrl_ + '/api/v1/data/delivery/area/lists/pda/collect/new', // 专线揽收

  insertTookDel: _baseUrl_ + '/api/v1/data/delivery/area/admin/lists/new/del', // 专线揽收 删除

  deliverList: _baseUrl_ + '/api/v1/admin/goods/detailed/list', //快件明细

  deliverExc: _baseUrl_ + '/api/v1/admin/goods/abnormal/category', //異常件下拉選擇

  deliverDetail: _baseUrl_ + '/api/v1/admin/goods', //快件詳情

  deliverDelete: _baseUrl_ + '/api/v1/admin/goods/del', //快件删除

  deliverUpdate: _baseUrl_ + '/api/v1/admin/goods/edit', //快件更新

  deliverExport_old: _baseUrl_ + '/api/v1/admin/goods/export', //快件導出(取消)

  bagNumberExport: _baseUrl_ + '/api/v1/express/storage/excel/record', // da baohao

  deliverExport_new: _baseUrl_ + '/api/v1/admin/goods/export/unsigned', //快件導出(取消)

  deliverExport_new_zh: _baseUrl_ + '/api/v1/admin/goods/export/unsigned', //快件導出(取消)

  deliverExport: _baseUrl_ + '/api/v1/admin/goods/data/excel/info', //快件導出

  deliverExport_zh: _baseUrl_ + '/api/v1/admin/goods/data/excel/info/zh', //快件導出

  deliverFexport: _baseUrl_ + '/api/v1/admin/goods/fexport', //報表導出

  delSack: _baseUrl_ + '/api/v1/admin/delSack', //移除快遞袋

  deliverExcList: _baseUrl_ + '/api/v1/admin/goods', //異常件

  deliverExcEdit: _baseUrl_ + '/api/v1/admin/goods/abnormal/handle', //處理異常件

  getBagNumber: _baseUrl_ + '/api/v1/express/storage/numbers', //获取袋号

  bagNumberdel: _baseUrl_ + '/api/v1/express/storage/record/del', //袋号del

  getrecordList: _baseUrl_ + '/api/v1/express/storage/record', //获取袋号列表

  //**** 澳門倉庫入出庫 **** 3 API count
  macaoScanIn: _baseUrl_ + '/api/v1/admin/goods/warehousing', //澳門倉庫入庫

  macaoScanOut: _baseUrl_ + '/api/v1/admin/goods/macaoOut', //澳門倉庫出庫

  macaoInList: _baseUrl_ + '/api/v1/admin/goods/warehousing2', //澳門入庫列表

  //**** 澳門門店 **** 17 API count
  shopOnShelves: _baseUrl_ + '/api/v1/admin/goods/shelf/on', //門店上架

  shelvesList: _baseUrl_ + '/api/v1/admin/basic/shelves', //貨架號列表

  shelvesAllList: _baseUrl_ + '/api/v1/admin/basic/shelvesall', //貨架號列表(未簽收)

  shopAdd: _baseUrl_ + '/api/v1/admin/store', //新增門店

  shopDetail: _baseUrl_ + '/api/v1/admin/store', //門店詳情  /:id, get

  shopDelete: _baseUrl_ + '/api/v1/admin/store', //删除門店, /:id, delete

  shopRestore: _baseUrl_ + '/api/v1/admin/store/restore', //還原删除門店, /:id, post

  shopUploadImage: _baseUrl_ + '/api/v1/admin/store/updateimages', //門店圖片上傳 post

  shopDelImage: _baseUrl_ + '/api/v1/store/image/del', //門店圖片  删除

  shopSignetodoRemark: _baseUrl_ + '/api/v1/admin/goood/remarks', //已簽收備註

  shopSignedRemark: _baseUrl_ + '/api/v1/admin/goood/remarks', //已簽收備註

  getSignInfo: _baseUrl_ + '/api/v1/admin/pay/cost', //收款簽收，獲取積分和收款金額

  getSignInfo_new: _baseUrl_ + '/api/v1/admin/pay/costs/info', //收款簽收，獲取積分和收款金額

  getSignInfos: _baseUrl_ + '/api/v1/admin/pay/costs',

  moreDelivery: _baseUrl_ + '/api/v1/admin/goods/setdelivery', // 多件修改送货上门

  dailyCount: _baseUrl_ + '/api/v1/admin/dailyouttime', //統計每日集運幫快遞數量

  dailyCountStore: _baseUrl_ + '/api/v1/admin/dailyouttimestore', //統計每日集運幫各個門店快遞數量

  dailyCountStoreNew: _baseUrl_ + '/api/v1/jyb/admin/staff/store/count', //統計每日集運幫各個門店快遞數量 new

  exportDailyCountStoreNew:
    _baseUrl_ + '/api/v1/jyb/admin/staff/store/count/excel', //統計每日集運幫各個門店快遞數量 导出

  payByNew: _baseUrl_ + '/api/v1/admin/pay/polymerization', //支付方式(單一)

  stockscanInList: _baseUrl_ + '/api/v1/basics/stock/index', //記錄掃描列表

  stockscanIn: _baseUrl_ + '/api/v1/basics/stock/insert', //記錄掃描列表->增加

  paymix: _baseUrl_ + '/api/v1/admin/pay/paymix', // 簽收方式

  paymix_new: _baseUrl_ + '/api/v1/admin/pay/paymix/new', // 新版簽收方式  （icbc支付）

  paymix_new2: _baseUrl_ + '/api/v1/admin/icbc/san/payinfo', // 新版簽收方式

  paymix_new_result: _baseUrl_ + '/api/v1/admin/icbc/query/payinfo', // 新版簽收方式 2  主動查詢

  paymix_new_cancel: _baseUrl_ + '/api/v1/admin/icbc/cancel/payinfo', // 新版簽收方式 2  取消

  paymix_new_sanredo: _baseUrl_ + '/api/v1/admin/icbc/sanredo/payinfo', // 新版簽收方式 2  冲正

  paymix_new_refund: _baseUrl_ + '/api/v1/admin/icbc/refund/payinfo', // 新版簽收方式 2  退款

  paymix_new_order: _baseUrl_ + '/api/v1/admin/icbc/san/payinfo/over', // 新版簽收方式 2  改快件状态

  overtimelist: _baseUrl_ + '/api/v1/jyb/order/outtime/list', //超時件列表

  overtimereturning: _baseUrl_ + '/api/v1/jyb/order/outtime/timeoutset', //超時件->快件已取,待回倉

  overtimereturned: _baseUrl_ + '/api/v1/jyb/order/outtime/timeoutsetover', //超時件->快件已取,已回倉

  overtimedestroy: _baseUrl_ + '/api/v1/jyb/order/outtime/writeofforder', //超時件->核銷

  //*** 積分管理 *** 11 API routes
  addIntegral: _baseUrl_ + '/api/v1/admin/member', //積分充值

  integralLog: _baseUrl_ + '/api/v1/admin/integral/log', //積分日誌

  integralNewLog: _baseUrl_ + '/api/v1/admin/integral/log/list', //新積分日誌

  integralLogExport: _baseUrl_ + '/api/v1/admin/goods/integral', //積分日誌Excel導出

  integralNewLogExport: _baseUrl_ + '/api/v1/admin/goods/integralnew', //新積分日誌Excel導出

  creditList: _baseUrl_ + '/api/v1/admin/basic/credit', //充值積分列表

  creditEdit: _baseUrl_ + '/api/v1/admin/basic/credit', //充值積分修改/增加

  creditDelete: _baseUrl_ + '/api/v1/admin/basic/credit', //充值積分刪除

  // credit2List: _baseUrl_ + "/api/v1/admin/basic/credit2", //活動積分列表

  // credit2Edit: _baseUrl_ + "/api/v1/admin/basic/credit2", //活動積分修改/增加

  // credit2Delete: _baseUrl_ + "/api/v1/admin/basic/credit2", //活動積分刪除

  creditAdminList: _baseUrl_ + '/api/v1/admin/basic/credits/list', //充值積分列表

  creditAdminEdit: _baseUrl_ + '/api/v1/admin/basic/credit', //充值積分修改/增加

  creditTypeOption: _baseUrl_ + '/api/v1/admin/basic/credit/list/Type', //充值贈送積分或集金幣列表

  creditTypeOptionEdit: _baseUrl_ + '/api/v1/admin/basic/credit/updateType', //充值贈送積分或集金幣列表

  // creditAdminDelete: _baseUrl_ + "/api/v1/admin/basic/credit", //充值積分刪除

  //*** 管理員管理 *** 6 API routes
  adminList: _baseUrl_ + '/api/v1/admin/member2', //管理員列表

  adminLog: _baseUrl_ + '/api/v1/admin/memberlog', //管理員日誌

  adminDetail: _baseUrl_ + '/api/v1/admin/member2', //管理員詳情

  adminUpdate: _baseUrl_ + '/api/v1/admin/member2', //管理員更新

  adminDelete: _baseUrl_ + '/api/v1/admin/member2/delete', //管理員刪除

  adminRole: _baseUrl_ + '/api/v1/admin/member2/role', //管理員規則

  //*** 用户管理 *** 5 API routes
  userList: _baseUrl_ + '/api/v1/admin/member', //用户列表

  userData: _baseUrl_ + '/api/v1/admin/member/data', //用户統計

  userUpdate: _baseUrl_ + '/api/v1/admin/member', //修改用户信息 /:id

  userUpdate_new: _baseUrl_ + '/api/v1/admin/set/user/infos/update', //修改用户信息 /:id

  userDelete: _baseUrl_ + '/api/v1/admin/member', //删除用户信息 /:id

  integralNewAdd: _baseUrl_ + '/api/v1/admin/integral/addintegral', //用戶積分用戶充值(新版)

  addUser: _baseUrl_ + '/api/v1/admin/set/user/infos/register', //新增用户

  delUserWx: _baseUrl_ + '/api/v1/admin/set/user/infos/rmwxopenid', // 解绑微信

  //*** 後台設置 *** 32 API routes
  deliverHomeAdd: _baseUrl_ + '/api/v1/delivery/insert', //送貨上門設定->新增 POST

  deliverHomeList: _baseUrl_ + '/api/v1/delivery/list', //送貨上門設定->列表 GET

  deliverHomeEdit: _baseUrl_ + '/api/v1/delivery/edit', //送貨上門設定->區域修改 POST

  deliverHomeDelete: _baseUrl_ + '/api/v1/delivery/deldata', //送貨上門設定->删除 POST

  shelvesDetail: _baseUrl_ + '/api/v1/admin/basic/shelves', //貨架號詳情 /id

  shelvesAdd: _baseUrl_ + '/api/v1/admin/basic/shelves', //新增貨架號

  shelvesUpdate: _baseUrl_ + '/api/v1/admin/basic/shelves', //更新貨架號 /id

  shelvesDelete: _baseUrl_ + '/api/v1/admin/basic/shelves', //删除貨架號 /id delete

  shelvesPdf: _baseUrl_ + '/api/v1/admin/basic/shelves/pdf', //貨架生成標簽pdf /id

  shelvesUpload: _baseUrl_ + '/api/v1/admin/basic/shelves/import', //貨架導入

  customDocList: _baseUrl_ + '/api/v1/admin/goods/detailed/list', //報關資料列表

  customDocUpload: _baseUrl_ + '/api/v1/admin/goods/detailed/import', //報關資料導入

  customDocDetail: _baseUrl_ + '/api/v1/admin/goods/detailed', //報關資料詳情 /:id,

  customDocAdd: _baseUrl_ + '/api/v1/admin/goods/detailed/add', //添加報關資料

  customDocUpdate: _baseUrl_ + '/api/v1/admin/goods/detailed/edit', //更新報關資料  /:id

  customDocDelete: _baseUrl_ + '/api/v1/admin/goods/detailed/del', //刪除報關資料 /:id delete

  bannerList: _baseUrl_ + '/api/v1/admin/basic/banner', //banner列表

  bannerAdd: _baseUrl_ + '/api/v1/admin/basic/banner', //新增banner

  bannerlistRead: _baseUrl_ + '/api/v1/admin/basic/listsBanner', //讀取修改banner /:id

  bannerEdit: _baseUrl_ + '/api/v1/admin/basic/banner', //修改banner /:id

  bannerDelete: _baseUrl_ + '/api/v1/admin/basic/banner', //删除banner /:id  delete

  uploadImg: _baseUrl_ + '/api/v1/upload/image', //上傳圖片

  feedBack: _baseUrl_ + '/api/v1/admin/basic/feedback', //問題反饋

  feedBackEdit: _baseUrl_ + '/api/v1/admin/basic/feedback/show', //問題反饋->回覆

  PushFeedBack: _baseUrl_ + '/api/v1/admin/basic/push', //問題反饋->推送

  articleList: _baseUrl_ + '/api/v1/article/categories/lists', //文章管理->列表

  articleCreate: _baseUrl_ + '/api/v1/article/categories/create', //文章管理->添加

  articleEdit: _baseUrl_ + '/api/v1/article/categories/edit', //文章管理->修改

  articleDetail: _baseUrl_ + '/api/v1/article', //文章管理->單個文章獲取

  articleDelete: _baseUrl_ + '/api/v1/article/del', //文章管理->删除

  versionList: _baseUrl_ + '/api/v1/admin/basic/version', //版本更新列表

  versionEdit: _baseUrl_ + '/api/v1/admin/basic/version', //版本更新修改->增加

  versionDelete: _baseUrl_ + '/api/v1/admin/basic/version', //版本更新刪除

  appNotificationManageList: _baseUrl_ + '/api/v1/noti/notices/liset', //通知列表

  appNotificationManageDel: _baseUrl_ + '/api/v1/noti/notices/del', //刪除

  appNotificationManageSet: _baseUrl_ + '/api/v1/noti/setNotice', //設置通知列表

  appNotificationManageStatusEdit: _baseUrl_ + '/api/v1/noti/notices/status', //通知狀態修改

  appRecommendedManageList: _baseUrl_ + '/api/v1/jyb/app/advertise/admin/lists', //推荐列表

  appRecommendedAdd: _baseUrl_ + '/api/v1/jyb/app/advertise/admin/insert', //推荐新增

  appRecommendedChildAdd:
    _baseUrl_ + '/api/v1/jyb/app/advertise/admin/carouse/insert', //推荐子新增

  appRecommendedEditImg:
    _baseUrl_ + '/api/v1/jyb/app/advertise/admin/carouse/update', //推荐子修改

  appRecommendedSet: _baseUrl_ + '/api/v1/jyb/app/advertise/admin/update', //推荐修改

  appRecommendedSetStatus:
    _baseUrl_ + '/api/v1/jyb/app/advertise/admin/carouse/editstatus', //推荐修改状态

  appRecommendedStatusEdit: _baseUrl_ + '/api/v1/noti/notices/status', //推荐修改状态

  appRecommendedMdel: _baseUrl_ + '/api/v1/jyb/app/advertise/admin/dels', //推荐删除

  appRecommendedDel: _baseUrl_ + '/api/v1/jyb/app/advertise/admin/carouse/dels', //推荐子删除

  addFees: _baseUrl_ + '/api/v1/admin/pay/advanceOrder/insert', //新增费用

  updateFees: _baseUrl_ + '/api/v1/admin/pay/advanceOrder/update', //更新费用

  listFees: _baseUrl_ + '/api/v1/admin/pay/goodspaycategory/list', //列表 费用

  //*** 啟動廣告管理 ***  5 API routes
  advertiserManage: _baseUrl_ + '/api/v1/basics/nav/home/page/admin', //啟動廣告列表

  advertiserManageAdd: _baseUrl_ + '/api/v1/basics/nav/home/page/add', //啟動廣告列表-新增

  advertiserManageDel: _baseUrl_ + '/api/v1/basics/nav/home/page/del', //啟動廣告列表-刪除

  advertiserManageEdit: _baseUrl_ + '/api/v1/basics/nav/home/page/edit', //啟動廣告列表-修改

  advertiserManageEditImage:
    _baseUrl_ + '/api/v1/basics/nav/home/page/editimage', //啟動廣告列表-修改-圖片

  //*** 投訴類型管理 ***  4 API routes
  complaintManageList: _baseUrl_ + '/api/v1/basic/admin/feedback/type/list', //投訴類型設置列表

  complaintManageListDel: _baseUrl_ + '/api/v1/basic/admin/feedback/type/del', //投訴類型設置刪除

  complaintManageListEdit: _baseUrl_ + '/api/v1/basic/admin/feedback/type/edit', //投訴類型設置修改

  complaintManageListAdd: _baseUrl_ + '/api/v1/basic/admin/feedback/type/add', //投訴類型設置新增

  //*** 送貨上門 ***  4 API routes
  deliveryList: _baseUrl_ + '/api/v1/admin/goods/delivery', //待配送訂單，配送中訂單，已配送訂單

  setDeliveryStatus: _baseUrl_ + '/api/v1/admin/goods/setdelivery', //單號轉為送貨上門

  deliveryListToShop: _baseUrl_ + '/api/v1/admin/goods/deliverylist', //送货上门门店

  deliverySigntodo: _baseUrl_ + '/api/v1/admin/pay/newpoly', //送貨上門簽收

  deliverySigntodo_jpoint: _baseUrl_ + '/api/v1/admin/pc/pay/jpoint', //送貨上門簽收jpoint

  //*** 財務管理 list *** 2 API routes
  payOrderflow_export: _baseUrl_ + '/api/v1/admin/goods/orderflowexport',

  payInfoList: _baseUrl_ + '/api/v1/admin/goods/flow', //財務管理list

  payInfoList_Orderflow: _baseUrl_ + '/api/v1/admin/goods/orderflow', //通過流水號搜索單號

  //*** 集金幣 *** 7 API routes
  jpointlogsList: _baseUrl_ + '/api/v1/jpoint/logs/list', //集金幣日誌

  jpointlogsEditList: _baseUrl_ + '/api/v1/jpoint/logs/edit', //集金幣日誌->修改

  jpointroleList: _baseUrl_ + '/api/v1/jpoint/list/role', //集金幣規則

  jpointroleAdd: _baseUrl_ + '/api/v1/jpoint/role/add', //集金幣規則->增加

  jpointroleEdit: _baseUrl_ + '/api/v1/jpoint/roles', //集金幣規則->修改

  jpointroleType: _baseUrl_ + '/api/v1/jpoint/role/type', //集金幣類型

  jpointlogExcel: _baseUrl_ + '/api/v1/jpoint/log/excel', //集金幣Excel

  //*** 同城配送 *** 20 API routes
  samecityAdminAdd: _baseUrl_ + '/api/v1/admin/company/add', //創建公司用戶（主用戶）

  samecityUserList: _baseUrl_ + '/api/v1/admin/company/list', //主用戶列表

  discountList: _baseUrl_ + '/api/v1/admin/discount/list', // /api/v1/admin/discount/list

  samecityUserListEdit: _baseUrl_ + '/api/v1/admin/company/edit', //主用戶列表修改

  samecityUserListSoftDelete: _baseUrl_ + '/api/v1/admin/company/del', //主用戶列表軟刪除

  samecityUserListRecovey: _baseUrl_ + '/api/v1/admin/company/forceDelete', //主用戶列表恢復軟刪除數據

  samecityChildAdd: _baseUrl_ + '/api/v1/admin/member2/0', //創建子賬戶

  samecityList: _baseUrl_ + '/api/v1/admin/goods', //同城列表

  samecityList_new: _baseUrl_ + '/api/v1/order/samecity/list', //同城列表  new

  samecityListAdd: _baseUrl_ + '/api/v1/admin/samecity/add', //同城入庫

  samecityListExcel: _baseUrl_ + '/api/v1/admin/samecity/update/excel', //同城Excel列表

  samecityListExcel_new: _baseUrl_ + '/api/v1/admin/samecity/update/excel', //同城Excel列表  new

  samecityListBarcode: _baseUrl_ + '/api/v1/admin/samecity/barCode',

  samecityDownloadExcel: _baseUrl_ + '/api/v1/download/push/excel/res',

  samecityMulteExcelList: _baseUrl_ + '/api/v1/admin/samecity/templist',

  samecityimportExcel: _baseUrl_ + '/api/v1/admin/samecity/update/filedata',

  samecityimportExcelDelete: _baseUrl_ + '/api/v1/admin/samecity/samepull',

  samecityMultiListDelete:
    _baseUrl_ + '/api/v1/admin/samecity/samelistinfo/sammelistdel',

  samecityMultiExcelListDetails:
    _baseUrl_ + '/api/v1/admin/samecity/samelistinfo',

  samecityMultiScanin: _baseUrl_ + '/api/v1/admin/samecity/pushOrder',

  samecityDetailEdit:
    _baseUrl_ + '/api/v1/admin/samecity/samelistinfo/samelistedit',

  samecityorderprint: _baseUrl_ + '/api/v1/admin/samecity/order/print',

  samecityorderbatchprint:
    _baseUrl_ + '/api/v1/admin/samecity/order/batchprint',

  //*** 客服專區 ***  1 API routes
  customer_register: _baseUrl_ + '/api/v1/user/register/link', //會員註冊

  customer_edit_status: _baseUrl_ + '/api/v1/jyb/admin/staff/order/update', //客服修改用户快件订单状态

  customer_recyclebin: _baseUrl_ + '/api/v1/jyb/admin/stadd/order/recycleBin', //订单回收站

  customer_ccf: _baseUrl_ + '/api/v1/admin/staff/query/claimInfo/list', //认领件确认

  customer_ccf_conf: _baseUrl_ + '/api/v1/admin/staff/user/claimInfo/set', //认领件确认

  customer_recyclebin_restore:
    _baseUrl_ + '/api/v1/jyb/admin/stadd/order/recycleBinrestore', //回收站订单恢复

  customer_recyclebin_del: _baseUrl_ + '/api/v1/jyb/admin/stadd/order/recycleBindel', //回收站订单彻底删除

  jifenoodel: _baseUrl_ + '/api/v1/admin/user/balance/info/set', //积分为0销毁

  customer_allgoods: _baseUrl_ + '/api/v1/jyb/admin/stadd/order/all/infos', //全部快件

  customer_soft_delete: _baseUrl_ + '/api/v1/jyb/admin/stadd/order/dels', //軟刪除

  customer_verify: _baseUrl_ + '/api/v1/jyb/admin/stadd/order/del/very', //驗證碼

  customer_integral_record: _baseUrl_ + '/api/v1/order/goods/online/list', //客服查询用户充值记录

  customer_integral_record_detail:
    _baseUrl_ + '/api/v1/order/goods/online/status', //查询用户-查看订单状态

  customer_edit_order_status:
    _baseUrl_ + '/api/v1/jyb/admin/staff/update/orders', //批量修改订单为任意状态

  advanceOrder_list: _baseUrl_ + '/api/v1/admin/order/advanceOrder/list', // 包裹預報列表

  expressinterception_list: _baseUrl_ + '/api/v1/order/order/interception/list', // 包裹拦截

  expressinterception_del: _baseUrl_ + '/api/v1/order/order/interception/del', // 包裹拦截删除

  expressinterception_add: _baseUrl_ + '/api/v1/order/order/interception/add', // 包裹拦截新增

  expressinterception_import: _baseUrl_ + '/api/v1/order/excl/load/infos', // excel 入库

  advanceOrder_edit: _baseUrl_ + '/api/v1/admin/order/advanceOrder/edit', // 包裹預報修改

  advanceOrder_del: _baseUrl_ + '/api/v1/admin/order/advanceOrder/del', // 包裹預報刪除

  //*** 統計報表 ***  3 API routes
  notonshelf: _baseUrl_ + '/api/v1/static/notonshelf',

  abnormalcount: _baseUrl_ + '/api/v1/static/abnormalcount',

  forecast: _baseUrl_ + '/api/v1/static/forecast',

  // 已入庫報表
  inorder: _baseUrl_ + '/api/v1/order/inorder/orderinfo',
  // 本地退
  returnedItems: _baseUrl_ + '/api/v1/returned/items/list',

  inorderex: _baseUrl_ + '/api/v1/order/inorder/orderinfo/excel',

  jifenoo: _baseUrl_ + '/api/v1/admin/user/balance/info',

  //*** 活動抽獎 ***  8 API routes
  eventActivityList: _baseUrl_ + '/api/v1/basic/activity/admin/list', //抽獎列表

  eventActivityUpdate: _baseUrl_ + '/api/v1/basic/activity/admin/list/update', //設置抽獎是否開啟

  eventActivityAdd: _baseUrl_ + '/api/v1/basic/activity/admin/insert/data', //添加抽獎

  eventActivityEdit: _baseUrl_ + '/api/v1/basic/activity/admin/list/edit', //修改抽獎名稱

  LotteryLogList: _baseUrl_ + '/api/v1/basic/activitylog/admin/list', //積分支付抽獎日誌

  eventLogList: _baseUrl_ + '/api/v1/basic/activitylog/admin/user/list', //活動詳情

  eventLogExcel:
    _baseUrl_ + '/api/v1/basic/activitylog/admin/user/listlog/excel', //抽獎日誌Excel

  eventActivityExcel:
    _baseUrl_ + '/api/v1/basic/activitylog/admin/user/listinfo/excels', //抽獎活動Excel

  //*** 加盟 ***  1 API routes
  franchiseList: _baseUrl_ + '/api/v1/user/Join/admin/list', //加盟列表

  //*** 派送專線 *** 4 API routes
  AreaList: _baseUrl_ + '/api/v1/data/delivery/area/admin/lists', //PC专线订单列表

  AreaList_new: _baseUrl_ + '/api/v1/data/delivery/area/admin/lists/new', //PC专线订单列表 new

  deliveryareaList: _baseUrl_ + '/api/v1/data/dedicatedline/admin/list', //专线部分-专线列表

  deliveryareaList_sign: _baseUrl_ + '/api/v1/order/delivery/set/order/over', //专线部分-签收

  deliveryareaEdit: _baseUrl_ + '/api/v1/data/dedicatedline/admin/edits', //专线部分-专线修改

  deliveryareaAdd: _baseUrl_ + '/api/v1/data/dedicatedline/admin/insert', //专线部分-专线增加

  deliveryareaDelete: _baseUrl_ + '/api/v1/data/dedicatedline/admin/dels', //专线部分-专线删除

  deliveryareaDateList: _baseUrl_ + '/api/v1/delivery/date/common/config/list', // 专线部分-日期列表

  deliveryareaDateEidt: _baseUrl_ + '/api/v1/delivery/date/common/config/edit', //专线部分-日期列表-修改

  deliveryareaDateAdd: _baseUrl_ + '/api/v1/delivery/date/common/config/add', //专线部分-日期列表-新增

  deliveryareaDateDel: _baseUrl_ + '/api/v1/delivery/date/common/config/del', //专线部分-日期列表-删除

  deliveryareaDateSynchronize:
    _baseUrl_ + '/api/v1/delivery/date/common/config/synchronize', //专线部分-日期列表-同步之列表

  deliveryareaDateListChildren:
    _baseUrl_ + '/api/v1/delivery/common/config/list', // 专线部分-日期列表 子

  deliveryareaDateEidtChildren:
    _baseUrl_ + '/api/v1/delivery/common/config/edit', //专线部分-日期列表-修改 子

  deliveryareaDateAddChildren: _baseUrl_ + '/api/v1/delivery/common/config/add', //专线部分-日期列表-新增 子

  deliveryareaDateDelChildren: _baseUrl_ + '/api/v1/delivery/common/config/del', //专线部分-日期列表-删除 子

  deliveryLimitGet: _baseUrl_ + '/api/v1/order/delivery/admin/configdate/list', //专线部分-长宽高限制

  deliveryLimitAdd:
    _baseUrl_ + '/api/v1/order/delivery/admin/configdate/insert', //专线部分-长宽高限制

  deliveryLimitDel: _baseUrl_ + '/api/v1/order/delivery/admin/configdate/del', //专线部分-长宽高限制

  deliveryLimitUpdate:
    _baseUrl_ + '/api/v1/order/delivery/admin/configdate/edit', //专线部分-长宽高限制

  //------------------------------------------------------------------
  deliveryareaTimeList:
    _baseUrl_ + '/api/v1/data/dedicatedline/admin/config/list', //专线列表-配置默认时间-列表

  deliveryareaTimeEdit:
    _baseUrl_ + '/api/v1/data/dedicatedline/admin/config/edits', //专线列表-配置默认时间-修改

  deliveryareaTimeAdd:
    _baseUrl_ + '/api/v1/data/dedicatedline/admin/config/inserts', //专线列表-配置默认时间-新增

  deliveryareaTimeDelete:
    _baseUrl_ + '/api/v1/data/dedicatedline/admin/config/dels', //专线列表-配置默认时间-刪除

  //------------------------------------------------------------------
  deliveryareaAddressList:
    _baseUrl_ + '/api/v1/data/delivery/admin/config/list', //专线列表-专线点-列表

  deliveryareaAddressEdit: _baseUrl_ + '/api/v1/data/delivery/admin', //专线列表-专线点-修改

  deliveryareaAddressAdd: _baseUrl_ + '/api/v1/data/delivery/admin/config', //专线列表-专线点-新增

  deliveryareaAddressAdd_new: _baseUrl_ + '/api/v1/delivery/node/config/add', //专线列表-专线点-新增 new

  deliveryareaAddressDelete: _baseUrl_ + '/api/v1/data/delivery/admin', //专线列表-专线点-刪除

  //------------------------------------------------------------------
  deliveryareaBuildingTimeList:
    _baseUrl_ + '/api/v1/data/delivery/admin/configdate/list', //专线点-配置时间部分-列表

  deliveryareaBuildingTimeEdit:
    _baseUrl_ + '/api/v1/data/delivery/admin/configdate/edits', //专线点-配置时间部分-修改

  deliveryareaBuildingTimesAdd:
    _baseUrl_ + '/api/v1/data/delivery/admin/configdate', //专线点-配置时间部分-新增

  deliveryareaBuildingTimeDelete:
    _baseUrl_ + '/api/v1/data/delivery/admin/configdate/dels', //专线列表-专线点-刪除

  //------------------------------------------------------------------

  deliveryareaConfigTimeList:
    _baseUrl_ + '/api/v1/data/dedicatedline/admin/configdate/list', //专线部分-设置专线部分跳出时间--列表

  deliveryareaConfigTimeEdit:
    _baseUrl_ + '/api/v1/data/dedicatedline/admin/configdate/edits', //专线部分-设置专线部分跳出时间--修改

  deliveryareaConfigTimeAdd:
    _baseUrl_ + '/api/v1/data/dedicatedline/admin/configdate/insert', //专线部分-设置专线部分跳出时间--新增

  deliveryareaConfigTimeDelete:
    _baseUrl_ + '/api/v1/data/dedicatedline/admin/configdate/dels', //专线部分-设置专线部分跳出时间--删除

  //-------------------------------------------------------------------

  deliveryareaExcelList:
    _baseUrl_ + '/api/v1/data/delivery/area/admin/listsExcel', //专线部分-Excel

  counterSums: _baseUrl_ + '/api/v1/jyb/order/delivery/calculate', //珠海倉 計算價格

  //-------------------------------------------------------------------

  //*** 轉店操作 *** 6 API routes
  transferList: _baseUrl_ + '/api/v1/jyb/admin/customer/strore/list', //轉店列表 GET

  settingDeliveryPerson: _baseUrl_ + '/api/v1/jyb/admin/customer/delivery/set', //後台設置派送人員 POST

  deliveryScanGoods: _baseUrl_ + '/api/v1/jyb/admin/customer/delivery/twist', //派送人員掃描快件 POST

  deliveryPersonList: _baseUrl_ + '/api/v1/jyb/admin/customer/delivery/list', //派送人員派送訂單列表 GET

  settingTranferStore: _baseUrl_ + '/api/v1/jyb/admin/customer/strore/set', //設置轉店 POST

  tranferStoreConfirm:
    _baseUrl_ + '/api/v1/jyb/admin/customer/delivery/confirmation', //門店確認操作 POST

  //------------------------兑换好物(商品)---------------------------------------

  commodityList: _baseUrl_ + '/api/v1/jyb/commodity/order/lists', //商品列表

  commodityAdd: _baseUrl_ + '/api/v1/jyb/commodity/order/insert', //商品添加

  commodityDelete: _baseUrl_ + '/api/v1/jyb/commodity/order/del', //商品删除

  commodityEdit: _baseUrl_ + '/api/v1/jyb/commodity/order/update', //商品修改

  commodityDesc: _baseUrl_ + '/api/v1/jyb/commodity/exchange/remark', //订单描述

  commodityDetailAdd: _baseUrl_ + '/api/v1/jyb/commodity/orderinfo/update', //商品详情添加

  //------------------------兑换好物(标签)----------------------------------------

  orderlabelAdd: _baseUrl_ + '/api/v1/jyb/commodity/orderlabel/insert', //标签添加

  orderlabelList: _baseUrl_ + '/api/v1/jyb/commodity/orderlabel/lists', //标签列表

  orderlabelEdit: _baseUrl_ + '/api/v1/jyb/commodity/orderlabel/update', //标签修改

  orderlabelDelete: _baseUrl_ + '/api/v1/jyb/commodity/orderlabel/del', //标签删除

  //------------------------兑换好物(上传商品图片)-----------------------------------

  commodityUploadImg: _baseUrl_ + '/api/v1/jyb/commodity/order/fileupdate', //上传商品图片

  //------------------------兑换好物(兑换訂單列表)----------------------------------------

  orderUsersList: _baseUrl_ + '/api/v1/jyb/commodity/exchange/lists', //兑换好物-PC用户已兑换列表

  orderUsersDetailList: _baseUrl_ + '/api/v1/jyb/commodity/exchange/lists/info', //兑换好物-PC用户已兑换详情列表

  orderExchangeShip: _baseUrl_ + '/api/v1/jyb/commodity/exchange/Ship', //后台一键发货

  exportOrders: _baseUrl_ + '/api/v1/jyb/commodity/exchange/lists/excel', // 導出兌換淚飆

  ordertypeList: _baseUrl_ + '/api/v1/jyb/commodity/ordertype/lists', // 商品分类list

  salesList: _baseUrl_ + '/api/v1/admin/sales', // 商品分类list

  salesList2: _baseUrl_ + '/api/v1/admin/getAdminCoupon', // 兑换列表

  ordertypeInsert: _baseUrl_ + '/api/v1/jyb/commodity/ordertype/insert', // 商品分类add

  salesadd: _baseUrl_ + '/api/v1/admin/sales', // 核销方

  ordertypeUpdate: _baseUrl_ + '/api/v1/jyb/commodity/ordertype/update', // 商品分类update

  ordertypeDel: _baseUrl_ + '/api/v1/jyb/commodity/ordertype/del', // 商品分类del

  ordertypeOnList: _baseUrl_ + '/api/v1/jyb/commodity/ordertype/lists/info', // 商品分类一维列表

  usertype4: _baseUrl_ + '/api/v1/admin/getUserSales', // 用户类型4

  orderSellerOnList: _baseUrl_ + '/api/v1/admin/sales', // 商品 核销方

  categorylist: _baseUrl_ + '/api/v1/jyb/commodity/category/list', // 商品分类一 添加

  categoryAdd: _baseUrl_ + '/api/v1/jyb/commodity/category/add', // 商品分类一

  categorydel: _baseUrl_ + '/api/v1/jyb/commodity/category/del', // 商品分类一 添加

  //------------------------btb模块----------------------------------------
  getBtbList: _baseUrl_ + '/api/v1/admin/order/usertype/list', // 获取btb列表

  exportExcl: _baseUrl_ + '/api/v1/admin/order/usertype/list/excel', // 导出
}
